import { getPdfSizes } from "helpers";
import { t } from "i18next";
import jsPDF from "jspdf";
import autoTable, { jsPDFDocument, Styles } from "jspdf-autotable";

import { ReturnDetails } from "../../returns.types";
import { getDeliveryAndDriver } from "./getDeliveryAndDriver";

interface renderDeliveryAndDriverProps {
  pdf: jsPDF;
  returnDetails: ReturnDetails;
  bigFontStyles: Partial<Styles>;
  normalFontStyles: Partial<Styles>;
}

export const renderDeliveryAndDriver = ({
  pdf,
  returnDetails,
  bigFontStyles,
  normalFontStyles
}: renderDeliveryAndDriverProps) => {
  const { pageWidth } = getPdfSizes(pdf);

  const { deliveryAddress, driverDetails } = getDeliveryAndDriver({
    returnDetails
  });

  autoTable(pdf, {
    theme: "plain",
    startY: (pdf as jsPDFDocument).lastAutoTable.finalY,
    margin: 0,
    styles: {
      lineColor: "#000000",
      lineWidth: 1,
      cellPadding: 0
    },
    head: [
      [
        {
          content: t("PICK UP ADDRESS"),
          styles: {
            valign: "top",
            halign: "left",
            fillColor: "#ffffff",
            textColor: "#000000",
            ...normalFontStyles,
            lineWidth: { left: 1, right: 1, top: 1 },
            cellPadding: { horizontal: 5, top: 5, bottom: 5 }
          }
        },
        {
          content: t("DRIVER"),
          styles: {
            valign: "top",
            halign: "left",
            fillColor: "#ffffff",
            textColor: "#000000",
            ...normalFontStyles,
            lineWidth: { left: 1, right: 1, top: 1 },
            cellPadding: { horizontal: 5, top: 5, bottom: 5 }
          }
        }
      ]
    ],
    body: [
      [
        {
          content: deliveryAddress,
          styles: {
            valign: "top",
            halign: "left",
            ...bigFontStyles,
            fontSize: 18,
            lineWidth: { left: 1, right: 1 },
            cellWidth: (pageWidth - 60) / 2,
            cellPadding: { horizontal: 5, vertical: 1 }
          }
        },
        {
          content: driverDetails,
          styles: {
            valign: "top",
            halign: "left",
            ...normalFontStyles,
            lineWidth: { left: 1, right: 1 },
            cellWidth: (pageWidth - 60) / 2,
            cellPadding: { horizontal: 5, vertical: 1 }
          }
        }
      ]
    ]
  });
};
